/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   index.ts
 */

import { memoizeRouteProps } from '@zcode/memoizers'
import type { State } from '@zcode/state-type'

export const getSearchUI = (state: State) => {
  return state.searchUI
}

export const getListablesCountsByPrice = (state: State) => {
  return state.currentSearch.countsBy.minPrice
}

export const getPathname = memoizeRouteProps((routeProps) => {
  const { location } = routeProps
  return location.pathname
})

export const selectIsPetFriendly = memoizeRouteProps((routeProps) => {
  const pathname = getPathname(routeProps)
  return pathname.includes('pet-friendly')
})

export const selectIsCheap = memoizeRouteProps((routeProps) => {
  const pathname = getPathname(routeProps)
  return pathname.includes('cheap')
})

export const selectIsLuxury = memoizeRouteProps((routeProps) => {
  const pathname = getPathname(routeProps)
  return pathname.includes('luxury')
})

export const selectIsFurnished = memoizeRouteProps((routeProps) => {
  const pathname = getPathname(routeProps)
  return pathname.includes('furnished')
})

export const selectIsShortTerm = memoizeRouteProps((routeProps) => {
  const pathname = getPathname(routeProps)
  return pathname.includes('short-term')
})

export const selectIsLowIncome = memoizeRouteProps((routeProps) => {
  const pathname = getPathname(routeProps)
  return pathname.includes('low-income')
})

export const selectIsNoSecurityDeposit = memoizeRouteProps((routeProps) => {
  const pathname = getPathname(routeProps)
  return pathname.includes('no-security-deposit')
})

export const selectIsMoveInSpecial = memoizeRouteProps((routeProps) => {
  const pathname = getPathname(routeProps)
  return pathname.includes('move-in-special')
})

export const selectIsUtilitiesIncluded = memoizeRouteProps((routeProps) => {
  const pathname = getPathname(routeProps)
  return pathname.includes('utilities-included')
})

export const selectIsVertical = memoizeRouteProps((routeProps) => {
  const isPetFriendly = selectIsPetFriendly(routeProps)
  const isCheap = selectIsCheap(routeProps)
  const isLowIncome = selectIsLowIncome(routeProps)
  const isLuxury = selectIsLuxury(routeProps)
  const isMoveInSpecial = selectIsMoveInSpecial(routeProps)
  const isFurnished = selectIsFurnished(routeProps)
  const isShortTerm = selectIsShortTerm(routeProps)
  const isNoSecurityDeposit = selectIsNoSecurityDeposit(routeProps)
  const isUtilitiesIncluded = selectIsUtilitiesIncluded(routeProps)

  return (
    isCheap ||
    isFurnished ||
    isLowIncome ||
    isLuxury ||
    isMoveInSpecial ||
    isNoSecurityDeposit ||
    isPetFriendly ||
    isShortTerm ||
    isUtilitiesIncluded
  )
})
